import { FunctionComponent } from "react";
import Loading from '../assets/animation/LoadingGif.gif'

interface LoadingGifProps {

}

const LoadingGif: FunctionComponent<LoadingGifProps> = () => {
  return ( <>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%'}}>
        <img src={Loading} alt="" />
    </div>
  </> );
}

export default LoadingGif;
